import {useQuery} from "@tanstack/react-query";
import {useEffect, useState} from "react";
import {getClaims} from "../services/ClaimService";
import {useLogout} from "./useLogout";

export function useClaims({enabled = true} = {}) {
    const [claims, setClaims] = useState([]);

    const logout = useLogout();
    const {data, isError, error, refetch, isFetching} = useQuery({
        queryKey: ["claims"],
        queryFn: getClaims,
        enabled: enabled,
        retry: false,
    });

    useEffect(() => {
        if (isError && error.response && error.response.status) {
            if (error.response.status === 401) {
                logout();
            }
        }
    }, [isError, error]);

    useEffect(() => {
        if (data) {
            setClaims(data);
        }
    }, [data]);

    return [claims, refetch, isFetching];
}
